export enum PricelistsOrderingEnum {
  Name = 'Name',
  Type = 'Type',
  Status = 'Status',
  CreatedAt = 'CreatedAt',
}
